/**** AUTHENTICATE USER PERMISSIONS HERE ****/
import CryptoJS from "crypto-js";
import { defineStore } from "pinia";

const SECRET_KEY = import.meta.env.VITE_APP_SECRET_KEY;

function tryParseJson(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return undefined;
  }
}

const storage = {
  getItem: (key) => {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined) return null;

    const plain = tryParseJson(raw);
    if (plain !== undefined) {
      // Migrate to encrypted form (best-effort)
      try {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(plain), SECRET_KEY).toString();
        localStorage.setItem(key, encrypted);
      } catch (e) {
        console.warn("Migration encrypt failed:", e);
      }
      return plain;
    }

    try {
      const decrypted = CryptoJS.AES.decrypt(raw, SECRET_KEY).toString(CryptoJS.enc.Utf8);
      if (!decrypted) return null;
      const parsed = JSON.parse(decrypted);
      return parsed;
    } catch (e) {
      console.warn("Decrypt failed:", e);
      return null;
    }
  },

  setItem: (key, value) => {
    try {
      const stringified = JSON.stringify(value);
      const encrypted = CryptoJS.AES.encrypt(stringified, SECRET_KEY).toString();
      localStorage.setItem(key, encrypted);
    } catch (e) {
      console.error("setItem encryption failed:", e);
      try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  },
};

const useCompanySettingStore = defineStore(
  "company_settings",
  () => {
    let setting = ref(null);
    const setValue = (value) => {
      setting.value = value;
    };

    const removeValue = () => {
      setting.value = 0;
    };
    return {
      setting,
      setValue,
      removeValue,
    };
  },
  {
    persist: {
      key: "company_settings",
      storage,
    },
  }
);

export default useCompanySettingStore;
